import React from 'react';
import AdminLayout from '../components/AdminLayout';

/**
 * System Settings Page
 * Admin page to configure platform-wide settings
 * Route: /admin/system-settings
 */
const SystemSettings: React.FC = () => {
    return (
        <AdminLayout
            showHeader={true}
            headerTitle="System Settings"
            headerSubtitle="Configure platform-wide settings and preferences"
        >
            <div className="space-y-6">
                    {/* General Settings */}
                    <div className="bg-white rounded-2xl p-6">
                        <h2 className="text-lg font-semibold text-[#0B111E] mb-4">General Settings</h2>
                        <div className="space-y-4">
                            <div className="flex items-center justify-between py-3 border-b border-[#F1F3F4]">
                                <div>
                                    <p className="text-sm font-medium text-[#0B111E]">Platform Name</p>
                                    <p className="text-xs text-[#757575]">Display name for the platform</p>
                                </div>
                                <button className="text-[#015FA6] text-sm font-medium hover:underline">
                                    Edit
                                </button>
                            </div>
                            <div className="flex items-center justify-between py-3 border-b border-[#F1F3F4]">
                                <div>
                                    <p className="text-sm font-medium text-[#0B111E]">Support Email</p>
                                    <p className="text-xs text-[#757575]">Contact email for user support</p>
                                </div>
                                <button className="text-[#015FA6] text-sm font-medium hover:underline">
                                    Edit
                                </button>
                            </div>
                            <div className="flex items-center justify-between py-3">
                                <div>
                                    <p className="text-sm font-medium text-[#0B111E]">Maintenance Mode</p>
                                    <p className="text-xs text-[#757575]">Enable maintenance mode for updates</p>
                                </div>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" className="sr-only peer" />
                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#015FA6]"></div>
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* Security Settings */}
                    <div className="bg-white rounded-2xl p-6">
                        <h2 className="text-lg font-semibold text-[#0B111E] mb-4">Security Settings</h2>
                        <div className="space-y-4">
                            <div className="flex items-center justify-between py-3 border-b border-[#F1F3F4]">
                                <div>
                                    <p className="text-sm font-medium text-[#0B111E]">Two-Factor Authentication</p>
                                    <p className="text-xs text-[#757575]">Require 2FA for admin accounts</p>
                                </div>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" className="sr-only peer" />
                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#015FA6]"></div>
                                </label>
                            </div>
                            <div className="flex items-center justify-between py-3">
                                <div>
                                    <p className="text-sm font-medium text-[#0B111E]">Session Timeout</p>
                                    <p className="text-xs text-[#757575]">Automatic logout after inactivity</p>
                                </div>
                                <button className="text-[#015FA6] text-sm font-medium hover:underline">
                                    Configure
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Email Settings */}
                    <div className="bg-white rounded-2xl p-6">
                        <h2 className="text-lg font-semibold text-[#0B111E] mb-4">Email Settings</h2>
                        <div className="space-y-4">
                            <div className="flex items-center justify-between py-3 border-b border-[#F1F3F4]">
                                <div>
                                    <p className="text-sm font-medium text-[#0B111E]">Email Notifications</p>
                                    <p className="text-xs text-[#757575]">Send email notifications to users</p>
                                </div>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" className="sr-only peer" defaultChecked />
                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#015FA6]"></div>
                                </label>
                            </div>
                            <div className="flex items-center justify-between py-3">
                                <div>
                                    <p className="text-sm font-medium text-[#0B111E]">SMTP Configuration</p>
                                    <p className="text-xs text-[#757575]">Configure email server settings</p>
                                </div>
                                <button className="text-[#015FA6] text-sm font-medium hover:underline">
                                    Configure
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
        </AdminLayout>
    );
};

export default SystemSettings;
